/** HTTP status code to user-facing title mapping. */
export const HTTP_STATUS_TITLES: Record<number, string> = {
  400: "Bad Request",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  417: "Expectation Failed",
  418: "I'm a teapot",
  422: "Unprocessable Entity",
};
